const GTM_SCRIPT_ID = "gtm-script";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

const ensureDataLayer = () => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
};

const injectGtmScript = (gtmId: string) => {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    gtmId
  )}`;
  script.id = GTM_SCRIPT_ID;
  document.head.appendChild(script);
};

export const initGtm = () => {
  if (typeof window === "undefined") {
    return;
  }

  const gtmId = process.env.REACT_APP_GTM_ID;
  if (!gtmId) {
    return;
  }
  // console.log("Initializing GTM with ID:", gtmId);
  ensureDataLayer();
  window.dataLayer!.push({
    "gtm.start": Date.now(),
    event: "gtm.js",
  });

  injectGtmScript(gtmId);
};

export const pushToDataLayer = (payload: Record<string, unknown>) => {
  if (typeof window === "undefined") {
    return;
  }
  ensureDataLayer();
  window.dataLayer!.push(payload);
};
